import { routerState, type LocationState } from './routerState';

export function getLocation(): LocationState {
  return routerState.value.location;
}
